(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("null"));
	else if(typeof define === 'function' && define.amd)
		define(["null"], factory);
	else if(typeof exports === 'object')
		exports["Redoc"] = factory(require("null"));
	else
		root["Redoc"] = factory(root["null"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__7707__) {
return 